import {RepoLayoutDataSchema, type RepoLayoutData} from '@github-ui/dotcom-schema/types/repos/v1/repo_layout'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {repoAppBuilder} from '../config/app-builder'

export const repoLayoutRoute = repoAppBuilder.createQueryRouteConfig('repoLayoutRoute', {
  path: '',
  queries: [
    mainQuery<RepoLayoutData>({
      schema: RepoLayoutDataSchema,
      queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
      // The global-asset map is version-safe only if captured once at load: keep the
      // embedded first-paint payload fresh forever so a soft-nav never refetches it
      // (which, post-deploy, could return URLs that mismatch the running JS).
      staleTime: Infinity,
      staleTimeForNavigation: Infinity,
    }),
  ],
})
